if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // Get product tags from data attribute
        this.productTags = this.dataset.productTags ? this.dataset.productTags.split(',').map(t => t.trim()) : [];
        
        // Get customer eligibility from data attribute (set via Liquid)
        this.customerCanOrder = this.dataset.customerCanOrder === 'true';
        
        console.log('Product Tags:', this.productTags);
        console.log('Customer Can Order:', this.customerCanOrder);
        
        // Check if product has free_product tag
        if (this.productTags.includes('free_product')) {
          console.log('Free product detected, checking eligibility...');
          this.checkFreeProductEligibility();
          
          // Listen for cart updates to re-check
          document.addEventListener('cart:updated', () => {
            this.checkFreeProductEligibility();
          });
          
          // Listen for cart removal events (Dawn theme)
          document.addEventListener('cart:refresh', () => {
            this.checkFreeProductEligibility();
          });
          
          // Listen for PubSub cart update events
          if (typeof subscribe !== 'undefined') {
            subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
              this.checkFreeProductEligibility();
            });
          }
        }
      }

      async checkFreeProductEligibility() {
        const productId = this.dataset.productId;
        if (!productId) return;

        try {
          // First, check if customer is allowed to order (from Liquid data attribute)
          if (!this.customerCanOrder) {
            console.log('Customer not eligible - already ordered once');
            this.disableButton('already_ordered');
            return;
          }

          // If customer is eligible, check if product is already in current cart
          const response = await fetch('/cart.js');
          const cart = await response.json();
          
          const productInCart = cart.items.some(item => {
            return item.product_id == productId;
          });
          
          console.log('Product in cart:', productInCart);
          
          if (productInCart) {
            this.disableButton('in_cart');
          } else {
            // Re-enable the button if product is not in cart and customer is eligible
            this.enableButton();
          }
        } catch (error) {
          console.error('Error checking eligibility:', error);
        }
      }

      disableButton(reason) {
        const isFrench = document.documentElement.lang === 'fr' || window.location.pathname.includes('/fr');
        
        let buttonText;
        if (reason === 'already_ordered') {
          buttonText = isFrench ? 'Déjà commandé' : 'Already Ordered';
        } else {
          buttonText = isFrench ? 'Déjà dans le panier' : 'Already in Cart';
        }
        
        console.log('Disabling button:', reason, buttonText);
        
        this.submitButton.setAttribute('disabled', 'disabled');
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButtonText.textContent = buttonText;
        this.submitButton.style.opacity = '0.5';
        this.submitButton.style.cursor = 'not-allowed';
      }

      enableButton() {
        console.log('Enabling button');
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButtonText.textContent = 'Add to cart';
        this.submitButton.style.opacity = '1';
        this.submitButton.style.cursor = 'pointer';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // CHECK IF VARIANT IS SELECTED
        if (this.variantIdInput.disabled || !this.variantIdInput.value) {
          // Show error message
          const errorDiv = this.querySelector('.variant-selection-error');
          if (errorDiv) {
            errorDiv.style.display = 'block';
            setTimeout(() => {
              errorDiv.style.display = 'none';
            }, 3000);
          }
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                
                // Trigger custom event for cart update
                setTimeout(() => {
                  document.dispatchEvent(new CustomEvent('cart:updated'));
                }, 300);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}